// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error--text[data-v-7479b7ae]{padding-bottom:10px}.portal-theme.theme--light.v-text-field[data-v-7479b7ae]:not(.v-input--has-state){color:#579fa7!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
